import React from 'react';
import { Box, Typography } from '@mui/material';

const StudentImage = ({ studentData, t, API_BASE_URL, renderCheckboxes }) => {
  if (!studentData) {
    return <Typography>{t('review.no_work_for_display')}</Typography>;
  }
  return (
    <Box style={{ position: 'relative', width: '90%', height: '900px' }}>
      <img
        src={`${API_BASE_URL}/api/radovi/${studentData.schoolid}/${studentData.image_url}`}
        //  src={`${API_BASE_URL}/api/povezani-radovi/${studentData.schoolid}/${studentData.id}.jpg`}
        alt={t('review.studentExam')}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          zIndex: 1
        }}
      />
      <Box
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 2
        }}
      >
        {renderCheckboxes()}
      </Box>
    </Box>
  );
};

export default StudentImage;
